import {action, Action} from 'easy-peasy';

interface Event {
    id: number;
    [key: string]: any;
}

export interface EventStore {
    items: Event[];
    loadEvents: Action<EventStore, Event[]>;
    searchPagesList: any[];
    setSearchPagesList: Action<EventStore, any[]>;
    searchCurrentPage: number;
    setSearchCurrentPage: Action<EventStore, number>;
    loading: boolean;
    setLoading: Action<EventStore, boolean>;
    reload: boolean;
    setReload: Action<EventStore, boolean>;
}

const eventStore: EventStore = {
    items: [],
    loadEvents: action((state, eventsList) => {
        state.items = eventsList;
    }),
    searchPagesList: [],
    setSearchPagesList: action((state, searchPagesList) => {
        state.searchPagesList = searchPagesList;
    }),
    searchCurrentPage: 1,
    setSearchCurrentPage: action((state, searchCurrentPage) => {
        state.searchCurrentPage = searchCurrentPage;
    }),
    loading: false,
    setLoading: action((state, loading) => {
        state.loading = loading;
    }),
    reload: false,
    setReload: action((state, value) => {
        state.reload = value;
    }),
};

export default eventStore;
